import React, { useState, useEffect, createContext, useContext } from 'react';

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await fetch('/api/check_session.php', {
          credentials: 'include',
        });
        const data = await res.json();
        console.log('check_session response:', data);
        if (data.loggedIn) {
          setUser({ id: data.userId, username: data.username, email: data.email, role: data.role, created_at: data.created_at });
        } else {
          setUser(null);
        }
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    checkSession();
  }, []);

  const login = async (pseudo, motdep) => {
  try {
    const response = await fetch('/api/log.php', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({ pseudo, motdep }),
    });

    const data = await response.json();

    if (data.success) {
      const res = await fetch('/api/check_session.php', {
        credentials: 'include',
      });
      const userData = await res.json();

      if (userData.loggedIn) {
        setUser({ 
          id: userData.userId, 
          username: userData.username, 
          email: userData.email, 
          role: userData.role,
          created_at: userData.created_at
        });

        return new Promise(resolve => {
          setTimeout(() => resolve({ success: true }), 50);
        });
      } else {
        return { success: false, message: "Impossible de valider la session." };
      }
    } else {
      return { success: false, message: data.message || 'Erreur inconnue' };
    }
  } catch {
    return { success: false, message: 'Erreur réseau' };
  }
};

  const logout = async () => {
    await fetch('/api/logout.php', {
      method: 'POST',
      credentials: 'include',
    });
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};